import { Typography } from '@/components/ui/typography'
import { inStoreShopFeeTypes } from '@/lib/services/pos-shop-fees/pos-shop-fees.terms'
import type { PosShopFeeCart } from '@/lib/services/pos-shop-fees/pos-shop-fees.types'
import { formatCurrency } from '@/lib/utils'

/**
 * The shop fee on an in-store order. Its amount depends on how the customer pays, so the cart shows it
 * once a payment collects it; until then the payment screen prices it and staff can remove it there.
 */
// The POS cart renders this before a cart exists, so cart can be missing.
export function PosCartShopFeeRow({ cart }: { cart: PosShopFeeCart | null | undefined }) {
  const fee = cart?.order_quote?.payment?.florist_fee
  const collected = cart?.order_quote?.totals?.shop_fee_paid ?? 0
  // A placed order's later payments carry no fee, so only a collected fee is shown then.
  if (collected <= 0 && (cart?.sales_order_id || inStoreShopFeeTypes(fee?.policy).length === 0)) {
    return null
  }
  const amount =
    collected > 0 ? formatCurrency(collected) : cart?.florist_fee_waiver ? 'Removed' : 'At payment'

  return (
    <div
      className="flex min-w-0 items-center justify-between gap-2"
      data-testid="pos-cart-shop-fee"
    >
      <Typography variant="label" tone="muted" className="truncate">
        {fee?.label || 'Shop fee'}
      </Typography>
      <Typography variant="label" tone="muted" className="shrink-0">
        {amount}
      </Typography>
    </div>
  )
}
